export default [
    {
        path: '/task/action',
        props: true,
        component: () => import('@/views/Task/Action'),
    },
];